import type { Column } from '@tanstack/react-table';

/**
 * Returns the min/max range for a column from faceted values.
 * Returns undefined if no range is available.
 */
export function getFilterRange<TData>(column: Column<TData>): { min: number; max: number } | undefined {
  const range = column.getFacetedMinMaxValues();

  if (!range) {
    return undefined;
  }

  const [min, max] = range;

  if (typeof min !== 'number' || typeof max !== 'number') {
    return undefined;
  }

  return { min, max };
}
